<template>
  <div class="return">
    <b-button pill variant="outline-primary" @click="goHome" v-if="section === 'benefits'">
      RETURN TO BENEFITS BY AREA
    </b-button>
    <h4 @click="goHome" class="returnDiagram" v-if="section === 'mpc'">
      <font-awesome-icon :icon="['far', 'angle-left']" />
      RETURN TO MPC TECHNOLOGY DIAGRAM
    </h4>
  </div>
</template>

<script>
export default {
  methods: {
    goHome () {
      this.$emit('go-home')
    }
  },
  name: 'ReturnButton',
  props: {
    section: {
      type: String,
      default: 'benefits'
    }
  }
}
</script>

<style lang="scss">
.return {
  &:hover {
    cursor: pointer;
  }
}
.returnDiagram:hover{color:#F9C20A;}
</style>
